import { useEffect, useState, type ReactElement } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, X } from "lucide-react";
import { onExportSubmitted } from "./exportCenterBus";

export function ExportCenterNoticeHost(): ReactElement | null {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    return onExportSubmitted(() => setOpen(true));
  }, []);
  if (!open) return null;
  return (
    <div className="export-center-notice" role="status">
      <CheckCircle2 size={22} aria-hidden />
      <div>
        <strong>Export request submitted successfully</strong>
        <p>Your file is being prepared. Visit the Export Center to check its status and download it when ready.</p>
        <Link to="/download-tasks" onClick={() => setOpen(false)}>
          Go to Export Center →
        </Link>
      </div>
      <button type="button" className="export-center-notice-close" aria-label="Close" onClick={() => setOpen(false)}>
        <X size={16} />
      </button>
    </div>
  );
}
